export const IMAGES = {
  hero: "photo-1494412574643-ff11b0a5c1c3",
  aviation: "photo-1436491865332-7a61a109cc05",
  ghanaStreet: "photo-1669418989936-fae7f3cebd56",
  kingstonStreet: "photo-1605994543054-6ffbabbd8139",
  kingstonCity: "photo-1680030229338-093c0f85f006",
  barbadosStreet: "photo-1636728157814-17e3dd6cc94c",
  portOfSpain: "photo-1638531920378-22310bcf3100",
  georgetown: "photo-1589997169253-cd680c6fba7a",
  lagos: "photo-1648023199223-25d3622bcb13",
  waves: "photo-1541345141634-61212040fdc5",
  diplomacy: "photo-1531058020387-3be344556be6",
  streetAfrica: "photo-1680713660046-67b7350ed679",
  caribbeanStreet: "photo-1783173690429-36b95fc4ba77",
  savanna: "photo-1523805009345-7448845a9e53",
  beach: "photo-1505142468610-359e7d316be0",
  map: "photo-1521295121783-8a321d551ad2",
  ocean: "photo-1559827260-dc66d52bef19",
  landscape: "photo-1469474968028-56623f02e42e",
  tech: "photo-1573164713988-8665fc963095",
  reef: "photo-1544551763-46a013bb70d5",
  conference: "photo-1531058020387-3be344556be6",
  people: "photo-1529156069898-49953e39b3ac",
};

export const imgUrl = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "News & Analysis", to: "/#news" },
  { label: "Countries", to: "/countries" },
  { label: "Research", to: "/research" },
  { label: "Culture & Memory", to: "/#culture" },
  { label: "Climate & Health", to: "/#climate" },
  { label: "Trade & Innovation", to: "/#trade" },
  { label: "Multimedia", to: "/#multimedia" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT_REASONS = [
  "Editorial enquiry",
  "Research partnership",
  "Media request",
  "Submit a story",
  "Corrections",
  "Funding and institutional partnership",
  "General enquiry",
];

export const RIBBON_ITEMS = [
  "Governance",
  "Trade",
  "Health",
  "Climate Resilience",
  "Education",
  "Culture",
  "Innovation",
  "Reparatory Justice",
  "Air Connectivity",
  "Diaspora Investment",
  "Food Systems",
  "Creative Economies",
];

export const COUNTRIES = [
  {
    slug: "ghana",
    name: "Ghana",
    region: "West Africa",
    focus: "Governance, education and cultural cooperation on the Atlantic's eastern shore.",
    image: IMAGES.ghanaStreet,
  },
  {
    slug: "jamaica",
    name: "Jamaica",
    region: "Caribbean",
    focus: "Connectivity, health-workforce cooperation and creative-economy priorities.",
    image: IMAGES.kingstonStreet,
  },
  {
    slug: "barbados",
    name: "Barbados",
    region: "Caribbean",
    focus: "Climate resilience, diplomacy and small-state leadership.",
    image: IMAGES.barbadosStreet,
  },
  {
    slug: "trinidad-and-tobago",
    name: "Trinidad and Tobago",
    region: "Caribbean",
    focus: "Energy, enterprise and diaspora linkages.",
    image: IMAGES.portOfSpain,
  },
  {
    slug: "guyana",
    name: "Guyana",
    region: "South America · CARICOM",
    focus: "Growth, institutions and Caribbean–South American bridges.",
    image: IMAGES.georgetown,
  },
  {
    slug: "nigeria",
    name: "Nigeria",
    region: "West Africa",
    focus: "Scale, markets and cultural influence across the diaspora.",
    image: IMAGES.lagos,
  },
];

export const RESEARCH_ITEMS = [
  { title: "Jamaica Country Dossier", type: "Dossier", to: "/countries/jamaica" },
  { title: "Ghana–Jamaica Cooperation Tracker", type: "Tracker", to: "/research/cooperation-tracker" },
  { title: "Africa–CARICOM Institutional Map", type: "Institutional Map", to: "/research" },
  { title: "Health Workforce Migration Across the Atlantic", type: "Briefing", to: "/research" },
  { title: "Creative Economy Opportunities: Ghana and Jamaica", type: "Analysis", to: "/research" },
];

export const CULTURE_SERIES = [
  {
    title: "The Atlantic Memory Project",
    copy: "An ongoing public record of shared memory across the Atlantic world.",
    image: IMAGES.streetAfrica,
  },
  {
    title: "Routes of Rhythm",
    copy: "Tracing musical lineages between African and Caribbean sound.",
  },
  {
    title: "Names That Crossed the Ocean",
    copy: "What names carry, preserve and reveal about migration and survival.",
  },
  {
    title: "Food as Archive",
    copy: "Culinary memory as a living historical record.",
  },
  {
    title: "Faith Across the Atlantic",
    copy: "Spiritual traditions carried, adapted and sustained.",
  },
  {
    title: "Return Journeys",
    copy: "Stories of return, reconnection and belonging.",
  },
];

export const CLIMATE_TOPICS = [
  "Hurricanes & Storms",
  "Floods",
  "Coastal Erosion",
  "Public Health",
  "Food Systems",
  "Emergency Preparedness",
];

export const TRADE_TOPICS = [
  "Air Connectivity",
  "Maritime Routes",
  "AfCFTA–CARICOM",
  "Entrepreneurship",
  "Technology",
  "Creative Industries",
  "Diaspora Investment",
];

export const INTERVIEW_GROUPS = [
  "Policymakers",
  "Scholars",
  "Entrepreneurs",
  "Health Professionals",
  "Artists",
  "Community Leaders",
];

export const CONTACT_EMAILS = [
  { label: "General enquiries", note: "admin@atlanticbridgeinstitute.org", email: "admin@atlanticbridgeinstitute.org" },
  { label: "Editorial enquiries", note: "Use the contact form and select Editorial enquiry." },
  { label: "Partnership enquiries", note: "Use the contact form and select Research partnership." },
];
